// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"632":"d7a64366","787":"71243340","908":"8966c46c"}[chunkId] + ".chunk.js";
};